import React, { useEffect } from "react";
import "../style.scss";

export default function ExerciseDataPicker() {
  useEffect(() => {}, []);

  return (
    <div style={{ zIndex: 999 }} className="picker-modal-wrap">
      <div className="modal">
        <button className="btn modal-login">Auswählen</button>
        <button
          style={{ marginLeft: "5px" }}
          className="btn modal-login-close btn-login-light"
        >
          Abbrechen
        </button>
      </div>
    </div>
  );
}
